import { createContext } from 'react';
export const DatePickerContext = createContext(null);
